
import React, { useState, useEffect, useMemo } from 'react';
import AdSense from 'react-adsense';
import { Cookies } from '../../index.js';
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import axios from 'axios';
import Bannerprofile from '../../shop/ads/Bannerprofile.jsx';
import { alert_error, alert_success } from "../../AppContext.js";
import { MoonLoader } from "react-spinners";
import Statistic from '../../community/content/statistic.jsx';
import Post_content from '../../community/content/Blog_posts.jsx';
import Admin_edit from '../../community/admin/home_client.jsx';
import Language_i18 from '../../js/useNationalLanguage.jsx';
import Adblock_detect from "./adblock_detect.jsx";
import { useSpring, animated, useTrail } from "@react-spring/web";
import Authenticator from "../../community/profile/authenticator.jsx";
import { isLocalHost } from '../../shared/host_utils.js';

function Homehust() {
    const { i18n, lang } = Language_i18();
    const { slug_2 } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [dalaythongtin, setdalaythongtin] = useState(false);
    const [location_start, set_location_start] = useState('');
    const apikey = Cookies.get('apikey') || '';
    const [category_id, set_category_id] = useState('');
    const [data, setdata] = useState(false);
    const national_market = Cookies.get('national_market') || "en";

    const resolveLocalizedText = (value) => {
        if (value == null) return '';
        if (typeof value === 'string' || typeof value === 'number') return String(value);
        if (typeof value === 'object') {
            return value?.[i18n.language] || value?.[lang] || value?.en || value?.vi || '';
        }
        return '';
    };

    useEffect(() => {
        // Khi URL thay đổi, nếu data khác false thì reload lại trang
        if (dalaythongtin && location != location_start) {
            // Sử dụng reload lại trang, hoặc dùng window.location.href = newUrl;
            //   alert(location);
            window.location.reload();
            console.log('Đã thay đổi đường dẫn:', location.pathname);
        }
    }, [location, data]);
    useEffect(() => {
        set_location_start(location);
    }, []);
    function switch_router(item) {
        console.log(item);
        const myCookieValue = Cookies.get('apikey');
        if (item.url_mode == 'sub_domain') {
            window.location.href = item.url_redirect + '=key=' + myCookieValue;
        }
        else if (item.url_mode == 'native' || item.url_mode == 'native_app') {
            if (item.url_mode == 'native_app') {
                const userAgent = navigator.userAgent.toLowerCase();
                if (userAgent.includes("hustmedianative") || userAgent.includes("hustmedia-android")
                    || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') {
                } else {
                    alert_error('Vui lòng tải app để làm jop này');
                    return;
                }
            }
            navigate(item.url_redirect);
        }
        else if (item.url_mode == 'redirect') {
            window.open(item.url_redirect, '_blank');
        }
        else {
            alert_error('Lỗi url hãy liên hệ admin');
        }
    };
    const getMainDomain = () => {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        // Nếu có nhiều hơn 2 phần, lấy phần thứ hai từ cuối, ngược lại lấy phần đầu tiên
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    };

    const variant = useMemo(() => Math.floor(Math.random() * 3), []);

    // const bannerElement = (
    //     <div className="w-full flex justify-center">
    //         <a
    //             href="https://premium69.click/"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             className="block w-full max-w-xl mx-auto overflow-hidden rounded-2xl mb-0"
    //         >
    //             <img
    //                 src="https://hust.media/img/videos/banner.gif"
    //                 alt="HUST Media Banner"
    //                 className="w-full h-auto object-cover"
    //             />
    //         </a>
    //     </div>
    // );
    const bannerElement = (
        <div className="w-full max-w-xl mx-auto">
            <AdSense.Google
                client="ca-pub-4574266110812955"
                slot="3259681051"
                format="fluid"
                responsive="true"
                style={{
                    display: 'block',
                    width: '100%',
                    minWidth: '250px',
                    maxWidth: '100%',
                    height: 'auto',
                }}
            />
        </div>
    );
    // AdSense element
    const adElement = (
        <div className="w-full max-w-xl mx-auto">
            <AdSense.Google
                client="ca-pub-4574266110812955"
                slot="3259681051"
                format="fluid"
                responsive="true"
                style={{
                    display: 'block',
                    width: '100%',
                    minWidth: '250px',
                    maxWidth: '100%',
                    height: 'auto',
                }}
            />
        </div>
    );
    const [isExpanded, setIsExpanded] = useState(false);
    const [menuHeight, setMenuHeight] = useState(0);

    const toggleMenu = (value) => {
        if (!isExpanded) {
            setIsExpanded(!isExpanded);
            edit_category(value);
        }
        else if (isExpanded && category_id != value.id) {
            setMenuHeight(0);
            setTimeout(() => {
                setIsExpanded(!isExpanded);
                setTimeout(() => {
                    setIsExpanded(isExpanded);
                    edit_category(value);
                }, 50);
            }, 270);
        } else {
            setMenuHeight(0);
            setTimeout(() => {
                setIsExpanded(!isExpanded);
            }, 300);
        }
    };
    const edit_category = (value) => {
        console.log(value.url_mode);
        if (value.url_mode == 'native') {
            switch_router(value);
        }
        set_category_id(value.id);
    }
    useEffect(() => {
        if (isExpanded) {
            // Get the height of the menu content
            const contentHeight = document.getElementById('menu-content').scrollHeight;
            // Set menu height to the height of the content
            setMenuHeight(contentHeight);
        } else {
        }
    }, [isExpanded]);


    // Để ngoài component, không thay đổi
    const time_update = 5 * 60 * 60 * 1000;
    const currentDomain = window.location.hostname;
    useEffect(() => {
        // 1) Tính toán các giá trị side‑effect
        const myCookieValue = Cookies.get('apikey');
        const main_domain = !isLocalHost(window.location.hostname)
            ? (Cookies.get("main_domain") || getMainDomain() || "hust")
            : (Cookies.get("main_domain") || "hust");


        const category = slug_2 || 'home';
        const json_data = {
            apikey: myCookieValue,
            main_domain,
            national_market,
            category_pro: category,
        };

        // 2) Kiểm tra cache
        const key = `menu_main_${category}`;
        const raw = localStorage.getItem(key);
        const store = raw ? JSON.parse(raw) : null;

        if (
            store &&
            Date.now() - store.timestamp < time_update &&
            JSON.stringify(store.payload) === JSON.stringify(json_data)
            && !isLocalHost(currentDomain)
        ) {
            // Cache còn hạn và payload không đổi
            setdata(store.menu);
            setdalaythongtin(true);
            console.log(`Loaded "${category}" from cache.`);
        } else {
            // Cache hết hạn, payload thay đổi, hoặc không tồn tại
            localStorage.removeItem(key);
            console.log(`Cache expired/missing for "${category}", fetching new data.`);
            laythongtin(category, myCookieValue, main_domain, json_data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);  // Chỉ chạy 1 lần khi mount

    // Chỉnh lại để nhận thêm param cookie, domain, payload
    function laythongtin(value, myCookieValue, main_domain, json_data) {
        axios
            .get('https://node_js.hust.media/community/home_menu', {
                params: {
                    apikey: myCookieValue,
                    national_market,
                    category_pro: value,
                    main_domain,
                },
            })
            .then(response => {
                console.log(response.data);
                const menu = response.data.api_results.home_menu;
                const key = `menu_main_${value}`;

                // Lưu gọn store
                const store = {
                    timestamp: Date.now(),
                    menu,
                    payload: json_data,
                };
                localStorage.setItem(key, JSON.stringify(store));

                // Cập nhật state
                setdata(menu);
                setdalaythongtin(true);
            })
            .catch(error => {
                alert_error(error);
            });
    }
    const [hovered, setHovered] = useState(false);
    const [pressed, setPressed] = useState(false);

    const spring = useSpring({
        transform: pressed ? "translateY(1px) scale(0.995)" : "translateY(0px) scale(1)",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        config: { tension: 340, friction: 20 },
    });

    // tạo trail cho 3 blob lấp lánh
    const trail = useTrail(3, {
        opacity: hovered ? 1 : 0,
        y: hovered ? 12 : 0, // di chuyển xuống khi hover
        scale: hovered ? 1 : 0.8,
        config: { mass: 1, tension: 210, friction: 20 },
    });
    return (
        <>
            <div className="mx-2 ">
                {(window.location.hostname == 'hust.media' || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') &&
                    (
                        <div className="flex mt-1 max-w-md mx-auto">
                            <div className="">
                                <Bannerprofile chedo="qualityviews" />
                            </div>
                        </div>
                    )}
                {!dalaythongtin ? (<div className="mt-2 flex justify-center items-center">
                    <MoonLoader size={75} color="#003AA5" />{" "}
                </div>
                ) : (<>
                    {
                        !apikey ?
                            (<>
                                <Authenticator />
                            </>) :
                            (
                                <>
                                    <div className='mx-2 rounded-lg  shadow-xl px-1  max-w-screen-xl mx-auto'>
                                        {/* Thay thế <div className="row mt-1 "> */}
                                        {/* <div className="w-full bg-gradient-to-r from-pink-500 to-red-500 text-white text-center p-2 rounded-lg shadow-md">
                                            <div className="text-sm sm:text-base font-semibold leading-snug">
                                                👉 ✨ Đợt viral này chuyển đủ 100% mn ơi 💯❤️
                                                <br />
                                                Không thể tin nổi, quá uy tín luôn 😍🔥🙏 🚀
                                            </div>
                                        </div> */}
                                        <Adblock_detect />
                                        <div className="mt-1 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">

                                            {data && (
                                                <>
                                                    {data.map((item, index) => (
                                                        // Đưa key lên div này và thay class col-xl-4 bằng Tailwind
                                                        <div key={index} className="mt-0">
                                                            <div className="card mb-0 bg-pink-500 shadow-lg rounded-xl">
                                                                <div className="grid gap-2 relative overflow-visible"> {/* cho phép blob chiếu ra ngoài */}
                                                                    <div className="bg-white border-2 border-white rounded-lg shadow-md relative">
                                                                        <div className="bg-green-200 relative">

                                                                            {/* floating purple sparkles dưới nút */}
                                                                            {trail.map((props, i) => (
                                                                                <animated.span
                                                                                    key={i}
                                                                                    style={{
                                                                                        ...props,
                                                                                        position: "absolute",
                                                                                        left: `${12 + i * 18}%`,
                                                                                        bottom: 0,
                                                                                        width: 36,
                                                                                        height: 36,
                                                                                        borderRadius: 9999,
                                                                                        transformOrigin: "center",
                                                                                        background: isExpanded
                                                                                            ? "linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.6))" // trắng khi isExpanded = true
                                                                                            : "linear-gradient(135deg, rgba(128,0,128,0.8), rgba(200,0,200,0.6))" // tím khi isExpanded = false
                                                                                        ,
                                                                                        mixBlendMode: "screen",
                                                                                        transform: props.y.to(y => `translateY(${y}px)`),
                                                                                    }}
                                                                                    className="blur-md"
                                                                                />
                                                                            ))}


                                                                            <animated.button
                                                                                onClick={() => {
                                                                                    toggleMenu(item);  // logic cũ
                                                                                }}
                                                                                onMouseEnter={() => setHovered(true)}
                                                                                onMouseLeave={() => {
                                                                                    setHovered(false);
                                                                                    setPressed(false);
                                                                                }}
                                                                                onMouseDown={() => setPressed(true)}
                                                                                onMouseUp={() => setPressed(false)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter" || e.key === " ") toggleMenu(item);
                                                                                }}
                                                                                type="button"
                                                                                id="options-menu"
                                                                                aria-haspopup="true"
                                                                                aria-expanded="true"
                                                                                style={spring}
                                                                                className="py-2 w-full flex items-center justify-center rounded-full bg-gradient-to-r from-pink-400 to-purple-400 hover:from-purple-400 hover:to-pink-400 text-white text-xl font-extrabold shadow-2xl focus:outline-none relative z-10 transition-all duration-500 transform hover:scale-105 hover:rotate-1 hover:translate-y-1"
                                                                            >
                                                                                {item.category_img && (
                                                                                    <img
                                                                                        src={item.category_img}
                                                                                        alt="Placeholder"
                                                                                        className="ml-2 w-6 h-6 rounded-full ring-2 ring-white object-cover"
                                                                                    />
                                                                                )}


                                                                                <span className="mx-2 leading-1 select-none">
                                                                                    {resolveLocalizedText(item.category_name)}
                                                                                </span>


                                                                                {item.category_img && (
                                                                                    <img
                                                                                        src={item.category_img}
                                                                                        alt="Decorative"
                                                                                        className="ml-0 w-6 h-6 rounded-full ring-2 ring-white object-cover"
                                                                                    />
                                                                                )}


                                                                                <span className="absolute -top-2 -right-4 text-base opacity-80 select-none">✨</span>
                                                                            </animated.button>
                                                                            {/* chấm sáng dưới nút */}
                                                                            <div
                                                                                className={`absolute bottom-[-6px] left-1/2 transform -translate-x-1/2 w-3 h-3 rounded-full transition-colors duration-300 ${!isExpanded ? 'bg-purple-400' : 'bg-white'}`}
                                                                            />
                                                                            {isExpanded && category_id === item.id && (
                                                                                <div className="mx-2">
                                                                                    <div
                                                                                        className="w-full overflow-hidden transition-[height] duration-300 ease"
                                                                                        style={{ height: menuHeight }}
                                                                                    >
                                                                                        <div id="menu-content" className="flex flex-col space-y-0.2 py-1">
                                                                                            {item.data && item.data.map((svc, svcIdx) => (
                                                                                                <React.Fragment key={svcIdx}>
                                                                                                    <button
                                                                                                        onClick={() => switch_router(svc)}
                                                                                                        className="w-full px-2 py-1 bg-white rounded-xl border-2 border-pink-200 text-gray-700 hover:bg-gray-100"
                                                                                                    >
                                                                                                        <div className="flex items-center justify-center space-x-2">
                                                                                                            {svc.service_img && (
                                                                                                                <img src={svc.service_img} alt="" className="w-5 h-5" />
                                                                                                            )}
                                                                                                            <span className="font-medium text-base text-violet-700">
                                                                                                                {resolveLocalizedText(svc.service_name)}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        {svc.note && (
                                                                                                            <div className="text-xs mb-1" style={{ lineHeight: 1 }}>
                                                                                                                {resolveLocalizedText(svc.note)}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </button>

                                                                                                    {window.location.href.includes('hustadmin') && (
                                                                                                        <Admin_edit
                                                                                                            item={svc}
                                                                                                            menuHeight={menuHeight}
                                                                                                            setMenuHeight={setMenuHeight}
                                                                                                        />
                                                                                                    )}
                                                                                                </React.Fragment>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}

                                            {variant === 0 && (
                                                <>
                                                    {bannerElement}
                                                    {/* {adElement} */}
                                                </>
                                            )}
                                            {variant === 1 && (
                                                <>
                                                    {/* {adElement} */}
                                                    {bannerElement}
                                                </>
                                            )}
                                            {variant === 2 && bannerElement}

                                        </div>


                                        <Statistic />
                                        <Post_content mode={'hust_media'} show_start_load={'NO'} show_adsense={'NO'} show_adskeeper={'NO'} uri={'hello_world'} />

                                    </div>
                                </>)} </>)}
            </div >
            <br />
        </>
    )
}
export default Homehust
